import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { ScrollingModule } from '@angular/cdk/scrolling';

interface TablePreviewDialogData {
  cols?: any[];
  data?: any[];
  classes?: any;
  chatTableValue?: boolean;
}

@Component({
  selector: 'app-table-preview',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTableModule,
    CommonModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    ScrollingModule,
    TitleCasePipe
  ],
  templateUrl: './table-preview.html',
  styleUrl: './table-preview.scss',
})
export class TablePreview implements OnInit, OnChanges {

  private readonly dialogData = inject<TablePreviewDialogData | null>(MAT_DIALOG_DATA, { optional: true });

  @Input() cols: any[] = [];
  @Input() data: any[] = [];
  @Input() classes: any = {};
  @Input() chatTableValue: boolean = false;
  public tableData: any[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.dialogData) {
      this.cols = this.dialogData.cols ?? this.cols;
      this.data = this.dialogData.data ?? this.data;
      this.classes = this.dialogData.classes ?? this.classes;
      this.chatTableValue = this.dialogData.chatTableValue ?? this.chatTableValue;
    }
    this.tableData = this.data ?? [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] || changes['cols']) {
      this.tableData = this.data ?? [];
    }
  }



}
